import instanceService from './instance'

import { DEAL_SERVER_URL } from '../helpers/constants'

let instance = instanceService.instance(DEAL_SERVER_URL)

export const dealService = {
  addClientContract,
  getContract,
  getExtensionDeals,
  addExtensionDeals,
  getClientCashBoxes,
  getClientContracts,
  getCloseContractsCalculations,
  closeContracts,
  changeClientContract,
  cancelContract,
  getOperations,
  changeContractStatus,
  changeContractStatusRefund,
  changePositionsContract,
  transferDeals,
  getInventories,
  getInventoryDeals,
  getTotalSummInventoryDeals,
  transferSaledStore,
  overestimationDeals,
  transferSaledGoHran,
  transferSaledGarage,
  cancelOperation,
  transferContractToRetention,
  getNextContractNumber,
  contractPartialQuenching,
  getDealNumberOverdue,
  fetchDealNumbers
}

function getDealNumberOverdue(data) {
  const options = {
    method: 'POST',
    url: 'list/dealNumber',
    data
  }
  return instance(options)
}

function addClientContract(data) {
  const options = {
    method: 'POST',
    url: '/',
    data
  }
  return instance(options)
}

function getContract(dealId) {
  const options = {
    method: 'GET',
    url: `/${dealId}`
  }
  return instance(options)
}

function getClientContracts(payload) {
  const { id, ...rest } = payload
  const options = {
    method: 'POST',
    url: `/list/${id}`,
    data: { ...rest }
  }
  return instance(options)
}

function getExtensionDeals(data) {
  const options = {
    method: 'POST',
    url: '/extension/calculate',
    data
  }
  return instance(options)
}

function addExtensionDeals(data) {
  const options = {
    method: 'POST',
    url: '/extension',
    data,
  }
  return instance(options)
}

function getClientCashBoxes(clientId) {
  const options = {
    method: 'GET',
    url: `/client/${clientId}`,
  }
  return instance(options)
}

function getCloseContractsCalculations(data) {
  const options = {
    method: 'POST',
    url: `/closure/calculations`,
    data: data
  }
  return instance(options)
}

function closeContracts(data) {
  const options = {
    method: 'POST',
    url: `/closure`,
    data: data
  }
  return instance(options)
}

function cancelContract( {dealId, unnecessary = 'false'} ) {
  const options = {
    method: 'PUT',
    url: `/${dealId}/cancellation?unnecessary=${unnecessary}`,
    unnecessary
  }
  return instance(options)
}

function changeClientContract(dealId, data) {
  const options = {
    method: 'PATCH',
    url: `/${dealId}`,
    data
  }
  return instance(options)
}

function getOperations(dealId) {
  const options = {
    method: 'GET',
    url: `/operations/${dealId}`,
  }
  return instance(options)
}

function changeContractStatus(data) {
  const options = {
    method: 'PUT',
    url: `/transfer/status`,
    data
  }
  return instance(options)
}

function changeContractStatusRefund(data) {
  const options = {
    method: 'PUT',
    url: `/status/transfer/refund`,
    data
  }
  return instance(options)
}

function changePositionsContract({ data, dealId }) {
  const options = {
    method: 'PUT',
    url: `/${dealId}`,
    data
  }
  return instance(options)
}

function transferDeals(data) {
  const options = {
    method: 'POST',
    url: '/transfer/',
    data
  }
  return instance(options)
}

function getInventories(data) {
  const options = {
    method: 'POST',
    url: `/list/transfers`,
    data
  }
  return instance(options)
}

function getInventoryDeals(data) {
  const options = {
    method: 'POST',
    url: `/list/all`,
    data
  }
  return instance(options)
}

function getTotalSummInventoryDeals({ transferId, status }) {
  const options = {
    method: 'GET',
    url: `/transfer/${transferId}?status=${status}`
  }
  return instance(options)
}

function transferSaledStore(data) {
  const options = {
    method: 'POST',
    url: `/sale/store/`,
    data
  }
  return instance(options)
}

function transferSaledGoHran(data) {
  const options = {
    method: 'POST',
    url: `/sale/gohran/`,
    data
  }
  return instance(options)
}

function transferSaledGarage(data) {
  const options = {
    method: 'POST',
    url: `/sale/garage/`,
    data
  }
  return instance(options)
}

function overestimationDeals(data) {
  const options = {
    method: 'PUT',
    url: `/revaluation`,
    data
  }
  return instance(options)
}

function cancelOperation({ dealId, operationId }) {
  const options = {
    method: 'PUT',
    url: `/${dealId}/revert/${operationId}`,
  }
  return instance(options)
}

function transferContractToRetention ( {id, date} ) {
  const options = {
    method: 'PUT',
    url: `/redemption/${id}?date=${date}`,
  }
  return instance(options)
}

function getNextContractNumber (dealId) {
  const options = {
    method: 'GET',
    url: `/next/${dealId}`,
  }
  return instance(options)
}


function contractPartialQuenching (data) {
  const options = {
    method: 'POST',
    url: '/repayment',
    data
  }
  return instance(options)
}

function fetchDealNumbers(ids) {
  const options = {
    method: 'GET',
    url: `/numbers?ids=${ids.join(',')}`
  }
  return instance(options)
}
